import { CompanyWeightingType } from 'common/types/companyWeightingType';
import ThirdPartyCompanyEditor from '../../../shared/columns/editors/ThirdPartyCompanyEditor';

class ThirdPartyOwnerEditor extends ThirdPartyCompanyEditor {
    render() {
        return super.render('TBN', CompanyWeightingType.Owner);
    }
}

export default ThirdPartyOwnerEditor;
